import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux'
import { Dialog, DialogTitle, DialogContent, DialogActions, Tooltip, Button, TextField } from '@material-ui/core';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from 'react-i18next';

import { showAlertSnackbar } from '../../../reducers/uiSlice';
import { setBlindScanBatch} from '../../../actions/batchManagementActions';

const useStyles = makeStyles((theme)=> ({
      root: {
        zIndex: theme.zIndex.modal - 1
      },      
}))



// const BATCH_NO_PATTERN = /^[A-Z]+SUB-20\d{10}$/i;
// const BATCH_NO_PATTERN_MSG = "pls input batch with the right format!";


export function BlindScanBatchSetting(props) {

    const { handleClose, warehouse, flag } = props;    

    const classes = useStyles();
    const {t} = useTranslation('batchManagement');    
    const dispatch = useDispatch();

    // set default value as the current created blank_sub_Batch
    const [blindScanBatchNo,setBlindScanBatchNo] = useState(window.localStorage.getItem('blank_sub_batch_no'));

    const [isSubmitted,setIsSubmitted] = useState(false);

    const title = flag ? t('button_unset_blind_scan_batch') : t('button_set_blind_scan_batch');

    return (
        <Dialog className={classes.root}
            onClose={props.handleClose} 
            open={true}
            // fullWidth={false}
            // maxWidth='md'
            // scroll='body'
        >
            <DialogTitle>
                {title} 
                <Tooltip title={t('common:cancel')} aria-label="cancel" style={{float: "right"}}>
                    <CloseIcon onClick={handleClose}></CloseIcon>
                </Tooltip>        
            </DialogTitle>            
            <DialogContent dividers ></DialogContent>            
            {/* <ValidatorForm onSubmit={handleSubmit}>
            <TextValidator
                autoFocus
                label={t('blind_scan_batch_no')}
                InputLabelProps={{ shrink: true }}
                inputProps={{ pattern: "[A-Z]+SUB-20\d{10}" }}
                variant="outlined"
                fullWidth
                value={blindScanBatchNo}
                //onChange={(e)=> setBlindScanBatchNo(e.target.value)}
                onChange={handleChange}
                //validators={['required',`matchRegexp:${BATCH_NO_PATTERN}`]}
                // validators={['required',`matchRegexp:^[A-Z]+SUB-20\d{10}$`]}                
                // errorMessages={['Batch no is required',`${BATCH_NO_PATTERN_MSG}`]}
                style={{width: 300, paddingBottom: 16}}
            />
            </ValidatorForm> */}
            <form onSubmit={handleSubmit}>
                <TextField inputProps={{ pattern: "[A-Z]+SUB-20\d{10}" }}
                    autoFocus
                    label={t('blind_scan_batch_no')}
                    InputLabelProps={{ shrink: true }}                
                    variant="outlined"
                    fullWidth
                    value={blindScanBatchNo}
                    onChange={(e)=> (e.target.value ? setBlindScanBatchNo(e.target.value) : ' ')}
                    //onChange={handleChange}
                    //validators={['required',`matchRegexp:${BATCH_NO_PATTERN}`]}
                    // validators={['required',`matchRegexp:^[A-Z]+SUB-20\d{10}$`]}                
                    // errorMessages={['Batch no is required',`${BATCH_NO_PATTERN_MSG}`]}
                    style={{width: 300, paddingBottom: 16}}
                />
                <DialogActions >
                    <Button 
                        variant="contained" 
                        color='primary' 
                        onClick={handleClose}
                    >
                        {t('common:cancel')}
                    </Button>
                    <Button 
                        type="submit" 
                        variant="contained" 
                        color='primary' 
                        disabled={isSubmitted} 
                        onClick={handleSubmit} 
                    >
                        {t('common:submit')}
                    </Button>           
                </DialogActions>                
            </form>    
        </Dialog> 
    )

    /**
    * submit the secondary express request
    */
    function handleSubmit() {
        let regex = /^[A-Z]+SUB-20\d{10}$/i;
        let thirdRegex = /^[A-Z]{3}-[A-Z]{2}-\d{8}$/i;
        let msg = flag ? 'unset' : 'set';

        if (blindScanBatchNo && !regex.test(blindScanBatchNo) && !thirdRegex.test(blindScanBatchNo)) {
            return;            
        }

        if (!warehouse) {
            dispatch(showAlertSnackbar({type: "error", message: "Warehouse is Required!"}));
            return;
        }
        
        let params = {
            'blind_scan_batch': blindScanBatchNo,
            'warehouse': warehouse,
            'off': flag
        }

        preventFrequentPost();

        dispatch(setBlindScanBatch(params))
        .then((setBlindScanBatchResult) => {
            if (setBlindScanBatchResult === "FAIL") {
                dispatch(showAlertSnackbar({type: "error", message: `${msg} blind scan failed , please retry!`}));
            } else {
                dispatch(showAlertSnackbar({type: "info", message: `${msg} blind scan success!`}));
                handleClose();
            }            
        });     
    }    


    /**
     * to prevent the frequent post which may cause the unnecessary database burden, the user could only repost after 1 second
     */
     function preventFrequentPost() {
        setIsSubmitted(true, 
            setTimeout(() => setIsSubmitted(false), 1000)
        );    
    }

}
